import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import { Slider } from '@js/components/Slider.ts'
import { initGlobalAnimations } from '@js/animations/animations.ts'

document.addEventListener('DOMContentLoaded', () => {
  initGlobalAnimations()
})

window.Alpine = Alpine

Alpine.plugin(intersect)
Alpine.data('slider', Slider)
Alpine.start()
